import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(notas),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(watchNotas);

import { takeEvery, select, put } from 'redux-saga/effects';
import { NOTAS, zona } from '../actions';
import { getConfigGeneral } from '../selectors';

function notas() {
  var configGeneral, _ref, libroIdZonaNotas, numPaginaZonaNotas, numZonaZonaNotas;

  return _regeneratorRuntime.wrap(function notas$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(getConfigGeneral);

        case 2:
          configGeneral = _context.sent;
          _ref = configGeneral.zonaNotas || {
            libroIdZonaNotas: 'SB',
            numPaginaZonaNotas: 500,
            numZonaZonaNotas: 1
          }, libroIdZonaNotas = _ref.libroIdZonaNotas, numPaginaZonaNotas = _ref.numPaginaZonaNotas, numZonaZonaNotas = _ref.numZonaZonaNotas;
          _context.next = 6;
          return put(zona(libroIdZonaNotas, numPaginaZonaNotas, numZonaZonaNotas));

        case 6:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function watchNotas() {
  return _regeneratorRuntime.wrap(function watchNotas$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeEvery(NOTAS, notas);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

export default watchNotas;